export default {"src":"/_next/static/media/subSol1.370e488f.svg","height":56,"width":62};